<template>
 <div class="box">
  <div class="billing-shipping-wrapper" >
    <h3 class="h3-secondary billing-shipping-header">{{infoType}} Details</h3>
    <div class="billing-shipping-container">
    <div class="row">
      <div class="form-group col-md-6 col-12">
        <div class="required">
          <input type="text" v-model="form.first_name" :id="prefix+'-first_name'" class="form-control" required>
          <label :for="prefix + '-first_name'">First Name</label>
        </div>
      </div>
      <div class="form-group col-md-6 col-12">
        <div class="required">
          <input type="text" v-model="form.last_name" :id="prefix+'-last_name'" class="form-control" required >
          <label :for="prefix+'-last_name'">Last Name</label>
        </div>

      </div>
    </div>
    <div class="row" v-if="prefix === 'shipping'">
      <div class="form-group  col-md-6 col-12">
        <div class="required">
          <input v-model="form.email_address" v-validate="'required|email'" type="email" :id="prefix+'-email_address'" class="form-control" required>
          <label :for="prefix+'-email_address'">Email Address</label>
        </div>
      </div>
      <div class="form-group col-md-6 col-12">
        <div class="required">
          <input v-model="form.phone_number" v-validate="'required|numeric|digits:10'" :name="prefix+'-phone_number'" :id="prefix+'-phone_number'" class="form-control" required>
          <label :for="prefix+'-phone_number'">Phone Number</label>
          <span v-show="errors.has(prefix+'-phone_number')">Enter a ten digit phone number without dashes or spaces.</span>
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="required">
        <select
          class="form-control"
          :id="prefix+'-country'"
          :autocomplete="prefix+' country-name'"
          required
          v-model="form.country"
        >
          <option value="" >Select a Country...</option>
          <template v-if="flags.internationalShipping && countries.length">
            <option v-for="country in countries" :value="country.iso_3166_1_a2">{{ country.printable_name }}</option>
          </template>
          <option v-else :value="USA.code">{{ USA.name }}</option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-6 col-12">
        <div class="required">
          <input v-model="form.line1" type="text" :id="prefix+'-line1'" class="form-control" required>
          <label :for="prefix+'-line1'">Address</label><!---->
        </div>
      </div>
      <div class="form-group col-md-6 col-12">
        <div class="not-required">
          <input v-model="form.line2" type="text" :id="prefix+'-line2'"  class="form-control" required><!--[formControlName]="prefix+'-line2'"-->
          <label :for="prefix+'-line2'">Address 2</label>
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="required">
        <input v-model="form.postcode" type="text" :id="prefix+'-postcode'" required class="form-control">
        <label :for="prefix+'-postcode'">
          <span v-if="isUSA">ZIP Code</span>
          <span v-else>Postal Code</span>
        </label><!---->
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-6 col-12">
        <div class="required">
          <input type="text" v-model="form.city" :id="prefix+'-city'" required class="form-control">
          <label :for="prefix+'-city'">City</label>
        </div>
      </div>
      <div class="form-group col-md-6 col-12">
        <div :class="{'required': isUSA, 'not-required': !isUSA }">
          <!-- Show "select" for USA -->
          <select
            v-if="isUSA"
            class="form-control"
            :id="prefix+'-state'"
            :autocomplete="prefix+'-state'"
            v-model="form.state"
            required
          >
            <option value="">Select a State...</option>
            <option v-for="(state, st) in states" :value="st" :key="st">
              {{state}}
            </option>
          </select>
          <!-- Show "input" for other countries -->
          <input v-if=!isUSA type="text" v-model="form.state" :id="prefix+'-state'" required class="form-control">
          <label v-if=!isUSA :for="prefix+'-state'">Province</label>
        </div>
      </div>
    </div>
    </div>
  </div>
 </div>

</template>

<style scoped lang="scss">
@import '~scss/colors';

.billing-shipping-container{
   background-color: #ededed;
   border:1px solid $gray-1;
   padding: 1em;
}


</style>

<script>
  import {mapActions, mapGetters, mapMutations} from 'vuex';
  import states from '@/data/states.json';
  import {empty_address, isUSA, USA} from '@/lib/CheckoutLogic';

  const addressTypeShipping = 'Shipping'

  export default {
    props:{
      infoType: {
        type: String,
        default: addressTypeShipping,
      },
      value: {
        type: Object,
        default: empty_address()
      }
    },
    data() {
      return {
        USA,
        states,
        form: Object.assign({}, this.value)
      }
    },
    computed: {
      ...mapGetters(['flags', 'countries']),
      prefix() {
        return this.infoType.toLowerCase();
      },
      isUSA() {
        return isUSA(this.form.country);
      }
    },
    watch: {
      form: {
        deep: true,
        handler(val) {
          this.$emit('input', val);
        }
      },
      value(val) {
        if (JSON.stringify(val) != JSON.stringify(this.form)) {
          // When props change, update the form, but only if the
          // values are different. Otherwise an infinite loop occurs.
          this.form = Object.assign({}, val);
        }
      }
    },
    mounted() {
      // Sometimes the validation doesnt seem to trigger
      // on load, causing spurious differences in layout
      this.$validator.validate();

      if (this.flags.internationalShipping && this.countries.length === 0) {
        this.loadCountries();
      }
    },
    methods: {
      ...mapActions(['loadCountries'])
    },
  }
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/checkout/CustomerInfo.vue